// Small icon-button pair that switches a media list between grid and single-column views.
import React from "react";
import { FaTh, FaSquare } from "react-icons/fa";

const baseBtn = {
  background: "transparent",
  border: "1px solid rgba(255,255,255,0.15)",
  borderRadius: 6,
  padding: "4px 8px",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  color: "inherit",
};

const activeBtn = {
  ...baseBtn,
  background: "#253866",
  color: "#ffffff",
  borderColor: "#253866",
};

export default function MediaViewToggle({ view, onChange }) {
  return (
    <div role="group" aria-label="View mode" style={{ display: "inline-flex", gap: 4 }}>
      <button
        type="button"
        aria-pressed={view === "grid"}
        aria-label="Grid view"
        title="Grid view"
        onClick={() => onChange("grid")}
        style={view === "grid" ? activeBtn : baseBtn}
      >
        <FaTh size={16} />
      </button>
      <button
        type="button"
        aria-pressed={view === "list"}
        aria-label="Single column view"
        title="Single column view"
        onClick={() => onChange("list")}
        style={view === "list" ? activeBtn : baseBtn}
      >
        <FaSquare size={16} />
      </button>
    </div>
  );
}
